module.exports = __webpack_public_path__ + "img/81ADB3_D6ECEE_BFDEE1_AFD1D7-256px.882620a0.png";